import { render, staticRenderFns } from "./TourMode.vue?vue&type=template&id=3905027c&scoped=true"
import script from "./TourMode.vue?vue&type=script&lang=js"
export * from "./TourMode.vue?vue&type=script&lang=js"
import style0 from "./TourMode.vue?vue&type=style&index=0&id=3905027c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905027c",
  null
  
)

export default component.exports